module.exports = __webpack_public_path__ + "img/inspiration-bg.e13011cc.png";